import "core-js/modules/es.array.concat.js";
import { getReq } from './axios';
import { anaCreditExportParams } from './models';
var BASE_URL = "".concat(apiUrl, "/ana-credit-export");
export var getAnaCreditExports = function getAnaCreditExports() {
  return getReq(BASE_URL);
};
export var getAnaCreditExport = function getAnaCreditExport(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/download"), {
    responseType: 'blob'
  });
};
export var getAnaCreditNewCredit = function getAnaCreditNewCredit(params) {
  return getReq("".concat(BASE_URL, "/new-credits"), {
    params: anaCreditExportParams(params)
  });
};
export var exportAnaCreditNewCredit = function exportAnaCreditNewCredit(params) {
  return getReq("".concat(BASE_URL, "/new-credits"), {
    params: anaCreditExportParams(params),
    responseType: 'blob'
  });
};
export var getAnaCreditMonthlyCredits = function getAnaCreditMonthlyCredits(params) {
  return getReq("".concat(BASE_URL, "/monthly-credits"), {
    params: anaCreditExportParams(params)
  });
};
export var exportAnaCreditMonthlyCredit = function exportAnaCreditMonthlyCredit(params) {
  return getReq("".concat(BASE_URL, "/monthly-credits"), {
    params: anaCreditExportParams(params),
    responseType: 'blob'
  });
};
export var getAnaCreditQuarterlyCredits = function getAnaCreditQuarterlyCredits(params) {
  return getReq("".concat(BASE_URL, "/quarterly-credits"), {
    params: anaCreditExportParams(params)
  });
};
export var exportAnaCreditQuarterlyCredit = function exportAnaCreditQuarterlyCredit(params) {
  return getReq("".concat(BASE_URL, "/quarterly-credits"), {
    params: anaCreditExportParams(params),
    responseType: 'blob'
  });
};